import { z } from 'zod'
import { CampaignCostHandlingMethod, CampaignCategory, ExpenseEvidenceType } from '~/generated/graphql'
import {
  influencerBurdenRateSchema,
  influencerBurdenRateSchemaFields,
} from '~/features/campaign_input/BurdenRateSelector'
import { selectCostHandlingMethodSchemaFields } from '~/features/campaign_input/SelectCostHandlingMethod'
import { selectExpenseEvidenceTypeSchemaFields } from '~/features/campaign_input/SelectExpenseEvidenceType'
import { categoryField } from '~/features/campaign_input/type'
import { isBurdenRate } from '~/features/campaign_input/constants/burdenRate'

const schema = z.object({
  ...selectCostHandlingMethodSchemaFields,
  ...selectExpenseEvidenceTypeSchemaFields,
  ...categoryField,
  ...influencerBurdenRateSchemaFields,
})

/**
 * influencerBurdenRateのバリデーション関数
 */
export const validateInfluencerBurdenRate = (val: z.infer<typeof influencerBurdenRateSchema>, ctx: z.RefinementCtx) => {
  if (val.costHandlingMethod === CampaignCostHandlingMethod.ExpenseCampaign) {
    const rate = val.influencerBurdenRate
    // BURDEN_RATE_VALUESから自動的にバリデーション
    if (!isBurdenRate(rate)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '不正な負担率です',
        path: ['influencerBurdenRate'],
      })
    }
  } else {
    val.influencerBurdenRate = 0
  }
}

export const transformNoChangeCampaignIsNoExpense = (v: z.infer<typeof schema>) => {
  // 無償提供は証憑なし
  if (v.costHandlingMethod === CampaignCostHandlingMethod.NoChargeCampaign) {
    return {
      ...v,
      expenseEvidenceType: ExpenseEvidenceType.NoEvidence,
    }
  }

  // 店舗は領収書で確定
  if (v.category === CampaignCategory.Service) {
    return {
      ...v,
      expenseEvidenceType: ExpenseEvidenceType.Receipt,
    }
  }
  return v
}

export const validateExpenseSetting = (v: z.infer<typeof schema>, ctx: z.RefinementCtx) => {
  if (
    v.costHandlingMethod === CampaignCostHandlingMethod.ExpenseCampaign &&
    v.category === CampaignCategory.Product &&
    v.expenseEvidenceType === ExpenseEvidenceType.NoEvidence
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: '精算方法がインフルエンサー立替型の場合は証憑形式を選択してください',
      path: ['expenseEvidenceType'],
    })
    return z.NEVER
  }
  return v
}
